var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-icon',{attrs:{"container-none":"","title":_vm.icon.tooltip,"icon":_vm.icon.icon + ' ' + 'fa-2x',"variant":(_vm.icon.danger ? 'danger' : 'success')}})}
var staticRenderFns = []

export { render, staticRenderFns }